import { createApiHooks, useGenericGet } from '../../../../../hooks/use-api.hook';
import { apiClient } from '../../../../../services/api-client.service';
import type { Trail, TrailGetResponse, TrailListResponse } from '../types/trail.types';
import type { UseListParams } from '../../../../../types/pagination.types';
import { useMemo } from 'react';

const useTrailBasePath = () => {
  return useMemo(() => {
    return `/v1/admin/trails`;
  }, []);
};

export const useTrailHooks = () => {
  const trailBasePath = useTrailBasePath();

  return createApiHooks<Trail, TrailListResponse, never, never>({
    basePath: trailBasePath,
    queryKey: ['Trails'],
    apiClient,
  });
};

// Export the hook for getting trail details
export const useTrailGet = (id: string | number, queryOptions?: any) => {
  const trailBasePath = useTrailBasePath();
  return useGenericGet<TrailGetResponse>(
    `${trailBasePath}/${id.toString()}`,
    ['Trails', 'detail', id.toString()],
    apiClient,
    {
      enabled: !!id,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      ...queryOptions,
    }
  );
};

// Export the hook for getting trail list
export const useTrailList = (params: UseListParams) => {
  const { useList } = useTrailHooks();
  return useList(params);
};
